import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import { CarouselProvider, Slide, ButtonBack, ButtonNext } from "pure-react-carousel"
export { Slider } from "pure-react-carousel"

import { minWidth, when } from "utils"

import Icon from "icons"

export const Container = styled.div`
  padding: 3rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.component.background};

  ${minWidth.tablet`
    padding: 5rem 8.5rem;
  `}
`

export const Line = styled.div`
  width: 100%;
  height: 0.1rem;
  background-color: #222;
`

export const StyledCarousel = styled(CarouselProvider)`
  position: relative;
  width: calc(100% - 8rem);
  cursor: grab;

  ${minWidth.tablet`
    width: 100%;
  `}

  :active {
    cursor: grabbing;
  }

  div.carousel__inner-slide {
    position: static;
    display: flex;
  }

  .carousel__back-button:disabled,
  .carousel__next-button:disabled {
    pointer-events: none;

    svg {
      color: transparent;
    }
  }
`

export const StyledSlide = styled(Slide)`
  height: auto;
`

export const Content = styled.div`
  padding: 2.5rem 2rem;
`

export const Category = styled(Link)`
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 1.3rem;
  letter-spacing: 0.2rem;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.primaryBlue};
  display: block;
  padding: 0 0 1rem 0;
`

export const Text = styled(Link)`
  margin: 1rem 0;
  font-size: 1.6rem;
  line-height: 2rem;
`

export const Separator = styled.div`
  width: 0.15rem;
  margin-top: 2.5rem;
  background-color: transparent;

  ${minWidth.mobile`
    background-color: #222;
  `}

  ${when("isLastVisible")`
    background-color: transparent !important;
  `}
`

const GalleryIcon = styled(Icon)`
  position: absolute;
  top: 50%;

  ${when("left")`
    left: -5.55rem;
    transform: translateY(-50%) scale(0.58);

    ${minWidth.tablet`
      left: -4.5rem;
      transform: translateY(-50%);
    `}
  `}

  ${when("right")`
    right: -5.55rem;
    transform: translateY(-50%) rotate(180deg) scale(0.58);

    ${minWidth.tablet`
      right: -4.5rem;
      transform: translateY(-50%) rotate(180deg);
    `}
  `}
`

export const ArrowLeft = ({ ...props }) => (
  <ButtonBack {...props}>
    <GalleryIcon id="carousel-arrow" width={31} height={57} left="true" />
  </ButtonBack>
)

export const ArrowRight = ({ ...props }) => (
  <ButtonNext {...props}>
    <GalleryIcon id="carousel-arrow" width={31} height={57} right="true" />
  </ButtonNext>
)
